/* src/app/components/about/about.component.css */
.card-image {
  cursor: pointer;
}
.card p.function-title {
  margin-top: -12px;
  margin-bottom: 12px;
  line-height: 1.1rem;
}
/*# sourceMappingURL=about.component.css.map */
